import { render, staticRenderFns } from "./agravosPropostaList.vue?vue&type=template&id=8e1a0302"
import script from "./agravosPropostaList.vue?vue&type=script&lang=js"
export * from "./agravosPropostaList.vue?vue&type=script&lang=js"
import style0 from "./agravosPropostaList.vue?vue&type=style&index=0&id=8e1a0302&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports